const values = {
  0: "sm:pr-0",
  0.5: "sm:pr-0.5",
  1: "sm:pr-1",
  1.5: "sm:pr-1.5",
  2: "sm:pr-2",
  2.5: "sm:pr-2.5",
  3: "sm:pr-3",
  3.5: "sm:pr-3.5",
  4: "sm:pr-4",
  5: "sm:pr-5",
  6: "sm:pr-6",
  7: "sm:pr-7",
  8: "sm:pr-8",
  9: "sm:pr-9",
  10: "sm:pr-10",
  12: "sm:pr-12",
  14: "sm:pr-14",
  16: "sm:pr-16",
  20: "sm:pr-20",
  24: "sm:pr-24",
  28: "sm:pr-28",
  32: "sm:pr-32",
  36: "sm:pr-36",
  40: "sm:pr-40",
  44: "sm:pr-44",
  48: "sm:pr-48",
  52: "sm:pr-52",
  56: "sm:pr-56",
  60: "sm:pr-60",
  64: "sm:pr-64",
  72: "sm:pr-72",
  80: "sm:pr-80",
  96: "sm:pr-96",
};

export default function getPaddingRightSm(value) {
  return values[value];
}
